import type { PaymentConfirmedArtifactData } from '@eriko/shared-types';
import { formatCurrency } from '@eriko/shared-types';

const FLAVOR_LABEL: Record<PaymentConfirmedArtifactData['flavor'], string> = {
  payment_received: 'Payment received',
  bill_paid: 'Bill paid',
  purchase_recorded: 'Purchase recorded',
  sales_receipt_recorded: 'Sale recorded',
  refund_issued: 'Refund issued',
  credit_recorded: 'Credit recorded',
  deposit_recorded: 'Deposit recorded',
};

export function PaymentConfirmedCard({ data }: { data: PaymentConfirmedArtifactData }) {
  return (
    <div className="rounded-lg border border-green-200 bg-green-50/50 p-3 my-2 dark:border-green-900 dark:bg-green-950/40">
      <div className="flex items-center justify-between gap-2">
        <div className="text-sm font-medium text-green-900 dark:text-green-200">
          ✓ {FLAVOR_LABEL[data.flavor]} — {data.partyName}
        </div>
        <div className="text-sm font-mono text-green-900 dark:text-green-200">
          {formatCurrency(data.totalAmount, { currency: data.currency, fractionDigits: 2 })}
        </div>
      </div>
      <div className="mt-1 text-xs text-green-800 dark:text-green-300">
        {data.date}
        {data.bankAccount?.name ? ` · ${data.bankAccount.name}` : ''}
        {data.method ? ` · ${data.method.toLowerCase()}` : ''}
        {data.provider !== 'LOCAL' ? ` · synced to ${data.provider}` : ' · local only'}
      </div>
      {data.allocations && data.allocations.length > 0 && (
        <ul className="mt-2 space-y-0.5 text-xs text-green-900 dark:text-green-200">
          {data.allocations.map((a, i) => (
            <li key={i} className="flex justify-between">
              <span>{a.documentSummary}</span>
              <span className="font-mono">{formatCurrency(a.amount, { currency: data.currency, fractionDigits: 2 })}</span>
            </li>
          ))}
        </ul>
      )}
      {data.adjustment && (
        <div className="mt-2 text-xs text-amber-800 dark:text-amber-300">
          + {data.adjustment.type.toLowerCase().replace(/_/g, ' ')}{' '}
          {formatCurrency(data.adjustment.amount, { currency: data.currency, fractionDigits: 2 })}
          {data.adjustment.description ? ` (${data.adjustment.description})` : ''}
        </div>
      )}
      {data.warning && (
        <div className="mt-2 rounded border border-amber-300 bg-amber-50 px-2 py-1 text-xs text-amber-900 dark:border-amber-700 dark:bg-amber-950/50 dark:text-amber-200">
          ⚠ {data.warning}
        </div>
      )}
    </div>
  );
}
